import SearchResults from '../unstructured/SearchResults';

export default class SearchResultAdder
{
  static track(snowplow, contexts, vehicles, vehiclesCountPerGroup, vehiclesCountPerFranchise, vehiclesCountPerLocation, vehicleOfferIds) {
    const searchResultsEvent = new SearchResults(snowplow);
    searchResultsEvent.setContexts(contexts);
    searchResultsEvent.setData(
      vehicles,
      vehiclesCountPerGroup,
      vehiclesCountPerFranchise,
      vehiclesCountPerLocation,
      vehicleOfferIds,
    );
    searchResultsEvent.send();
  }
}
